module.exports = __webpack_public_path__ + "static/media/trees.90772a27.m4a";